import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subDays } from "date-fns";
import moment from "moment-timezone";
import { es } from "date-fns/locale";

function CustomDatePickerWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange } = props;
  const [selectedDate, setSelectedDate] = useState<Date | null>(null); // Para la fecha
  const [selectedTime, setSelectedTime] = useState<string>(""); // Para la hora

  // Parseamos el valor inicial al cargar
  useEffect(() => {
    if (value) {
      const date = new Date(value);
      setSelectedDate(date);
      const time = moment(date).format("HH:mm"); // Extraemos la hora en formato 24h
      setSelectedTime(time);
    } else {
      setSelectedDate(null);
      setSelectedTime("");
    }
  }, [value]);

  // Cuando cambia la fecha
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    updateDateTime(date, selectedTime); // Combinamos fecha y hora
  };

  // Cuando cambia la hora
  const handleTimeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const time = event.target.value;
    setSelectedTime(time);
    updateDateTime(selectedDate, time); // Combinamos fecha y hora
  };

  // Combina la fecha y la hora y envía el valor en formato ISO
  const updateDateTime = (date: Date | null, time: string) => {
    if (date && time) {
      const [hours, minutes] = time.split(":").map(Number);
      const updatedDate = new Date(date);
      updatedDate.setHours(hours, minutes, 0, 0); // Ajustamos la hora en la fecha
      var offset = moment().utcOffset();
      offset = offset / 60;
      const dateStr = moment(updatedDate).format("YYYY-MM-DDTHH:mm:ss.SSS+0" + offset +":00");
      onChange(dateStr);
    } else {
      onChange(undefined); // Si falta fecha u hora, enviamos undefined
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center", // Centra verticalmente los inputs
        gap: "10px", // Espaciado entre los inputs
      }}
    >
      {/* Input de fecha */}
      <DatePicker
        id={`${id}-date`}
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="dd 'de' MMMM 'de' yyyy" // Formato en español
        locale={es} // Establecer español
        minDate={subDays(new Date(), 5)}
        required={required}
        disabled={disabled || readonly}
        placeholderText="Selecciona una fecha"
        isClearable={true}
        autoComplete="off"
      />

      {/* Selector de horas */}
      <select
        id={`${id}-time`}
        value={selectedTime}
        onChange={handleTimeChange}
        required={required}
        disabled={disabled || readonly}
        style={{
          padding: "5px",
          fontSize: "14px",
        }}
      >
        <option value="" disabled>
          Hora
        </option>
        <option value="08:00">08:00</option>
        <option value="08:30">08:30</option>
        <option value="09:00">09:00</option>
        <option value="09:30">09:30</option>
        <option value="10:00">10:00</option>
        <option value="10:30">10:30</option>
        <option value="11:00">11:00</option>
        <option value="11:30">11:30</option>
        <option value="12:00">12:00</option>
        <option value="12:30">12:30</option>
        <option value="13:00">13:00</option>
        <option value="13:30">13:30</option>
        <option value="14:00">14:00</option>
        <option value="14:30">14:30</option>
        <option value="15:00">15:00</option>
        <option value="15:30">15:30</option>
        <option value="16:00">16:00</option>
        <option value="16:30">16:30</option>
        <option value="17:00">17:00</option>
        <option value="17:30">17:30</option>
        <option value="18:00">18:00</option>
        <option value="18:30">18:30</option>
        <option value="19:00">19:00</option>
        <option value="19:30">19:30</option>
        <option value="20:00">20:00</option>
        <option value="20:30">20:30</option>
        <option value="21:00">21:00</option>
        <option value="21:30">21:30</option>
        <option value="22:00">22:00</option>
        <option value="22:30">22:30</option>
        <option value="23:00">23:00</option>
        <option value="23:30">23:30</option>
      </select>
    </div>
  );
}

function BeelditDateTimeInput(props: any) {
  const { id, value, required, disabled, readonly, onChange } = props;

  return (
    <CustomDatePickerWidget
      id={id}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default BeelditDateTimeInput;
